import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../../features/auth/authSlice';
import { ThemeContext } from '../../../context/ThemeContext';

import { collection, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from "../../../config/firebase";

const Header = ({ onNote }) => {
  const { openMenuToggle, windowWidth } = useContext(ThemeContext);
  const [hasImmediateActivity, setHasImmediateActivity] = useState(false);
  const user = useSelector((state) => state.auth.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onLogout = async () => {
    await dispatch(logout());
    navigate('/login');
  };

  useEffect(() => {
    const fetchImmediateActivities = async () => {
      if (!user) return;

      const now = new Date();
      const in30Min = new Date(now.getTime() + 30 * 60000);

      const q = query(
        collection(db, 'meetings'),
        where('users', 'array-contains', user.uid),
        where('startDate', '>=', Timestamp.fromDate(now)),
        where('startDate', '<=', Timestamp.fromDate(in30Min))
      );

      const snapshot = await getDocs(q);
      const results = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(activity => activity.users?.includes(user.uid));

      setHasImmediateActivity(results.length > 0);
    };

    fetchImmediateActivities();

    // Opsiyonel: her 1 dakikada bir güncellemek istersen:
    const interval = setInterval(fetchImmediateActivities, 60 * 1000);
    return () => clearInterval(interval);
  }, [user]);

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                onClick={openMenuToggle}
                className="nav-item"
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#f5f5f5' }}>
                  <i className="fa fa-bars" aria-hidden="true" style={{ fontSize: '16px' }}></i>
                </div>
                <span className="d-none d-md-inline">Menü</span>
              </div>
            </div>

            <ul className="navbar-nav header-right main-notification">
              <Link as="li" to="/notification" className="nav-item me-2">
                <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#f5f5f5' }}>
                  <i className="fa fa-bell" aria-hidden="true" style={{ fontSize: '16px' }}></i>
                  {hasImmediateActivity && (
                    <span
                      className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
                      style={{ zIndex: 10, width: '8px', height: '8px' }}
                    ></span>
                  )}
                </div>
                <span className="ms-2 d-none d-md-inline">Bildirimler</span>
              </Link>

              <Link as="li" to="/MyProfile" className="nav-item me-2">
                <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#f5f5f5' }}>
                  <i className="fa fa-user" aria-hidden="true" style={{ fontSize: '16px' }}></i>
                </div>
                <span className="ms-2 d-none d-md-inline">Hesabım</span>
              </Link>

              <Link as="li" className="nav-item me-2" onClick={onLogout}>
                <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#f5f5f5', cursor: 'pointer' }}>
                  <i className="fa fa-power-off" aria-hidden="true" style={{ fontSize: '16px' }}></i>
                </div>
                <span className="ms-2 d-none d-md-inline">Çıkış</span>
              </Link>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
